export const paymentModeFr = {
  "Donner le Nom": "Donner le Nom",
  "Code": "Code",
  "Donner le Code": "Donner le Code",

  // server Side  

  "La methode deja existe.": "Le Mode de paiement deja existe.",
  "le nom est obligatoire.": "le nom est obligatoire.",
  "le code est obligatoire.": "le code est obligatoire.",
  

}